<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { Typography } from '@aryeo/runway'

const page = usePage()

const title = computed(() => page.props.meta.title)
const description = computed(() => page.props.meta.description)
</script>

<template>
  <div
    v-if="title || description"
    class="space-y-3 sm:flex sm:items-center sm:justify-between sm:space-x-4 sm:space-y-0 mb-3"
  >
    <div class="flex-1 min-w-0">
      <Typography variant="heading-md" as="h1">
        {{ title }}
      </Typography>

      <Typography v-if="description" as="p" variant="body-small" color="subtle" class="mt-3">
        {{ description }}
      </Typography>
    </div>
    <div>
      <slot name="actions" />
    </div>
  </div>
</template>
